import type { ReactNode } from "react"

export function AuthPageLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center overflow-auto px-4 py-6 sm:px-6 md:p-10">
      <div className="my-auto w-full max-w-sm md:max-w-3xl">{children}</div>
    </div>
  )
}
